import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = (route, state) => {
  const oauth = inject(OAuthService);
  console.log('AuthGuard - has valid access token?: ' + oauth.hasValidAccessToken());

  if(!oauth.hasValidAccessToken()){
    oauth.initLoginFlow();
  }
  return oauth.hasValidAccessToken();
};
